<app-view [justify]="ViewJustify.END" [spacingBottom]="Spacing.MEDIUM">
  <app-button
    type="primary"
    (handleClick)="addChallenge()"
    [spacingBottom]="Spacing.NONE"
    data-test-id="challenges-add-button"
    >{{ 'groupChallenges.add' | translate }}</app-button
  >
</app-view>
<div class="challenges-filter" data-test-id="challenges-filter">
  <app-heading titleLevel="3">{{
    'challenges.challenges' | translate
  }}</app-heading>
  <app-input
    type="search"
    size="small"
    [icon]="InputIcon.SEARCH"
    placeholder="{{ 'common.search' | translate }}"
    [inputValue]="searchInput"
    (typeahead)="getGroupChallenges()"
    data-test-id="challenges-search-input"
  />
</div>
<div class="status-filter-bar" data-test-id="challenges-status-filter">
  @for (option of statusOptions; track option.value) {
    <button
      class="status-filter-btn"
      [class.active]="statusFilter() === option.value"
      (click)="setStatusFilter(option.value)"
    >
      {{ option.label | translate }}
    </button>
  }
</div>
<div class="challenges-container">
  @if (isLoading()) {
  <app-spinner data-test-id="challenges-spinner"></app-spinner>
  } @else {
  <app-table
    [tableData]="filteredChallenges()"
    [config]="tableConfig"
    (handleOptionSelected)="onOptionSelected($event)"
    data-test-id="challenges-table"
  ></app-table>
  @if (!hasChallenges()) {
  <app-view [justify]="ViewJustify.CENTER">
    <app-text
      [spacingBottom]="24"
      data-test-id="challenges-no-challenges-text"
      >{{ 'challenges.noChallengesFound' | translate }}</app-text
    >
  </app-view>
  } }
</div>

<app-confirm-dialog
  [(isOpen)]="dialogOpen"
  (handlePrimaryButton)="closeDialog()"
  (handleSecondaryButton)="deleteChallenge()"
  title="{{ 'challenges.confirmDelete' | translate }}"
  subTitle="{{ 'challenges.confirmDeleteWarning' | translate }}"
  primaryText="{{ 'common.keep' | translate }}"
  secondaryText="{{ 'common.delete' | translate }}"
  data-test-id="challenges-confirm-dialog"
></app-confirm-dialog>
